import type { MeDto } from '@sara/api-client';

/**
 * Staff-only gate for the `/admin/*` route subtree.
 *
 * Only Gigpro staff (`User.isSuperAdmin` on the backend, mirrored on `MeDto`)
 * may access admin tooling like bulk-reprocess. Factored out of the route's
 * `beforeLoad` so the rule is independently testable, mirroring
 * `decideOrgEntry`.
 */
export function canAccessAdmin(me: Pick<MeDto, 'isSuperAdmin'>): boolean {
  return me.isSuperAdmin;
}
